import { createContext } from "react";

const GlobalLoaderContext = createContext();
export default GlobalLoaderContext;
